import React, { useState } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Input, Select } from "antd";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import {
	btnStyle,
	inputStyle,
	LandingTitle,
} from "../../lib/styles/styleLibrary";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import { fetchBanks, updateBankDetails } from "../../redux/actions/wallet";
import { useMutation, useQuery } from "react-query";
import { Loading } from "..";

const Wrapper = styled.div`
	${tw`p-2 h-full bg-white w-full flex flex-col container`}
	box-shadow: 0px 30px 60px rgba(32, 56, 85, 0.05);
	border-radius: 10px;
	@media (max-width: 1217px) {
		height: auto;
	}

	.ant-select-selection-search-input {
		padding-top: 15px !important;
	}
	.ant-select-selection-item,
	.ant-select-selection-placeholder {
		/* padding-top: 10px !important; */
		/* color: #dedef0 !important; */
		font-size: 0.875rem !important;
	}
	.ant-select-selection-placeholder {
		color: #db0a0a !important;
	}

	.ant-select-arrow {
		${tw`p-5 bg-appLightPink! rounded-full text-tiny! text-appPinkSaturated! flex! items-center! justify-center!`}
		padding: 10px;
		top: 45%;
		width: 8px;
		height: 8px;
	}
`;

const UpdateBankDetails = (props) => {
	const { account } = props;
	const [fields, setFields] = useState({
		bank_account_name: account?.accountName,
		bank_account_number: account?.accountNumber,
		bank_name: account?.bankName,
	});
	const { Option } = Select;

	const { data, isLoading } = useQuery("Banks", fetchBanks, {
		refetchOnWindowFocus: false,
	});
	// console.log("bank data \n", data);

	const { mutateAsync, isLoading: updateLoading } =
		useMutation(updateBankDetails);

	const handleUpdateBank = async () => {
		if (
			isEmpty(fields.bank_account_number) ||
			fields.bank_account_number.length !== 10
		) {
			Toast.fire({
				icon: "error",
				title: `Invalid account number`,
			});
			return;
		}
		if (isEmpty(fields.bank_name.trim())) {
			Toast.fire({
				icon: "error",
				title: `Please select transaction bank`,
			});
			return;
		}
		if (isEmpty(fields.bank_account_name.trim())) {
			Toast.fire({
				icon: "error",
				title: `Account name cannot be empty`,
			});
			return;
		}

		try {
			const response = await mutateAsync(fields);
			console.log("Update bank res: =====>\n", response.data);
			const { hasError } = response.data;
			if (hasError) {
				Toast.fire({
					icon: "error",
					title: `${response.data.errors.title}\n ${response.data.errors.message} `,
				});
				return;
			}
			Toast.fire({
				icon: "success",
				title: `${response.data.message} \n ${response.data.data}`,
			});
			props.refectchWalletData();
		} catch (err) {
			console.log("Error: ", err);
		}
	};

	return (
		<Wrapper>
			<div
				tw="mb-4 h-8 w-8 px-2 py-2 bg-gray-100 rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800) flex flex-col items-center justify-center"
				onClick={() => props.goBack()}>
				<ArrowLeftOutlined tw="hover:(text-purple-800 transform scale-125)" />
			</div>
			<LandingTitle tw="text-center text-lg! mb-4">
				Edit withdrawal bank
			</LandingTitle>

			<div>
				<div>
					<label tw="font-semibold text-base">Account number</label>
					<Input
						placeholder="1234567890"
						type="number"
						css={inputStyle}
						maxLength="10"
						tw="mt-4"
						value={fields.bank_account_number}
						onChange={(e) => {
							setFields({
								...fields,
								bank_account_number: e.target.value.trim(),
							});
						}}
					/>
				</div>
				<div>
					<label tw="font-semibold text-base">Bank</label>
					<Select
						css={inputStyle}
						tw="w-full pl-2 flex items-center mt-4"
						placeholder="Select Bank"
						value={fields.bank_name}
						onChange={(value) => {
							setFields({ ...fields, bank_name: value });
						}}
						bordered={false}
						loading={isLoading}
						defaultActiveFirstOption={true}
						optionFilterProp="children"
						showSearch
						filterOption={(input, option) =>
							option.children
								.toLowerCase()
								.indexOf(input.toLowerCase()) >= 0
						}
						filterSort={(optionA, optionB) =>
							optionA.children
								.toLowerCase()
								.localeCompare(optionB.children.toLowerCase())
						}>
						{data?.map((bank, i) => {
							return (
								<Option
									key={i}
									value={bank.name}
									tw="uppercase!">
									{bank.name}
								</Option>
							);
						})}
					</Select>
				</div>

				<div>
					<label tw="font-semibold text-lg">Account Name</label>
					<Input
						type="text"
						css={inputStyle}
						tw="mt-4 text-sm!"
						value={fields.bank_account_name}
						onChange={(e) => {
							setFields({
								...fields,
								bank_account_name: e.target.value,
							});
						}}
					/>
				</div>
			</div>

			<div tw="mt-4 mb-8">
				<button
					css={btnStyle}
					tw="rounded-lg"
					onClick={handleUpdateBank}>
					{updateLoading ? <Loading /> : "Save"}
				</button>
			</div>
		</Wrapper>
	);
};

export default UpdateBankDetails;
